
function ContactPage(){
    const googleMapURL = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3168.4076122296055!2d-122.17190768486346!3d37.42747447982416!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808fbb2a678bea9d%3A0x29cdf01a44fc687f!2sStanford%20University!5e0!3m2!1sen!2sin!4v1675403329811!5m2!1sen!2sin"
    const textareaSize = {
        height:200
    }
    const iframeStyle = {
        border: 1,
        height:500
    }
    return(
        <>
            <div className="container mt-2 mb-5">
                <div className="row fs-2 py-2 ps-5 fw-semibold headingCls">Get In Touch</div>
                <div className="row mt-3 border p-3 contactCardColor">
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-md-12">
                            <div className="input-group mb-3">
                                <span className="input-group-text px-3 bg-success text-light"><i className="fa-solid fa-user"></i></span>
                                <div className="form-floating">
                                    <input type="text" className="form-control fw-bold" placeholder="labelFloat" id="floatingInput"/>
                                    <label className="fw-bold" htmlFor="floatingInput">Name</label>
                                </div>
                            </div>
                            <div className="input-group mb-3">  
                                <span className="input-group-text px-3 bg-success text-light"><i className="fa-solid fa-envelope"></i></span>
                                <div className="form-floating">
                                    <input type="email" className="form-control fw-bold" placeholder="labelFloat" id="floatingemail"/>
                                    <label className="fw-bold" htmlFor="floatingemail">Email</label>
                                </div>
                            </div>
                            <div className="input-group mb-3">
                                <span className="input-group-text px-3 bg-success text-light"><i className="fa-solid fa-phone"></i></span>
                                <div className="form-floating">
                                <input type="phone" className="form-control fw-bold" placeholder="labelFloat" id="floatingphone"/>
                                <label className="fw-bold" htmlFor="floatingphone">Phone</label>
                                </div>
                            </div>
                            <div className="form-floating mb-2">
                                <textarea className="form-control fw-bold" style={textareaSize} placeholder="labelFloat" id="floatingTextarea"></textarea>
                                <label className="fw-bold" htmlFor="floatingTextarea">Your Message</label>
                            </div>
                            <div className="form-check mb-3">
                                <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault"/>
                                <label className="form-check-label fw-bold" htmlFor="flexCheckDefault">
                                Send Copy to my Mail
                                </label>
                            </div>
                            <div>
                                <button type="button" className="linkCls">Send Email</button>
                            </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <iframe title="This is a unique title" src={googleMapURL} style={iframeStyle} width="600" height="450" className="img-fluid" allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
                    </div>
                </div>
            </div>
        </>
    )
}export default ContactPage